"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toGregorian = void 0;
var date_splicer_1 = require("../date-splicer/date-splicer");
var is_leap_1 = require("../leap/is-leap");
var calculate_month_and_day_in_leap_year_1 = require("./calculate-month-and-day-in-leap-year");
var calculate_month_and_day_in_ordinary_year_1 = require("./calculate-month-and-day-in-ordinary-year");
var calculate_year_1 = require("./calculate-year");
var how_many_days_are_past_1 = require("./how-many-days-are-past");
var how_many_days_are_past_from_gregorian_1 = require("./how-many-days-are-past-from-gregorian");
var gregorian_validation_1 = require("../validation/gregorian-validation");
var getNumeric_1 = require("../getNumeric");
var getDay_1 = require("../getDay");
function toGregorian(date) {
    var _a = date_splicer_1.dateSplicer(date), year = _a.year, month = _a.month, day = _a.day, hour = _a.hour, minute = _a.minute, second = _a.second, miliSecond = _a.miliSecond;
    var _b = gregorian_validation_1.gregorianValidation(year, month, day, hour, minute, second, miliSecond), staus = _b.staus, YEAR = _b.YEAR, MONTH = _b.MONTH, DAY = _b.DAY, HOUR = _b.HOUR, MINUTE = _b.MINUTE, SECOND = _b.SECOND, MILISECOND = _b.MILISECOND;
    if (!staus) {
        return {
            year: 0,
            month: 0,
            day: 0,
            hour: 0,
            minute: 0,
            second: 0,
            miliSecond: 0,
            numeric: 0,
            dayName: -1
        };
    }
    else {
        var JDays = how_many_days_are_past_1.howManyDaysArePast(MONTH, DAY);
        var GDays = how_many_days_are_past_from_gregorian_1.howManyDaysArePastFromGregorian(JDays, YEAR);
        var GYear = calculate_year_1.calculateYear(YEAR, JDays);
        var MonthAndDay = void 0;
        if (is_leap_1.isLeap(GYear)) {
            MonthAndDay = calculate_month_and_day_in_leap_year_1.calculateMonthAndDayInLeapYear(GDays);
        }
        else {
            MonthAndDay = calculate_month_and_day_in_ordinary_year_1.calculateMonthAndDayInOrdinaryYear(GDays);
        }
        var numeric = getNumeric_1.getNumeric(GYear, MonthAndDay.month, MonthAndDay.day, HOUR, MINUTE, SECOND, MILISECOND);
        var DAY_NAME = getDay_1.getDay(GYear, MonthAndDay.month, MonthAndDay.day, HOUR, MINUTE, SECOND, MILISECOND);
        return {
            year: GYear,
            month: MonthAndDay.month,
            day: MonthAndDay.day,
            hour: HOUR,
            minute: MINUTE,
            second: SECOND,
            miliSecond: MILISECOND,
            numeric: numeric,
            dayName: DAY_NAME
        };
    }
}
exports.toGregorian = toGregorian;
